import {Route} from '@tanstack/react-location';
import {EventDetail} from './pages/event-detail/event-detail';
import {Events} from './pages/events/events';
import {Intro} from './pages/intro/intro';
import {Setlist} from './pages/setlist/setlist';
import {Register} from './pages/register/register';
import {Verification} from './pages/verification/verification';
import {Verify} from './pages/verify/verify';
import {Wallet} from './pages/wallet/wallet';
import {TransactionDetail} from './pages/transaction-detail/transaction-detail';
import {NftDetail} from './pages/nft-detail/nft-detail';

export const routes: Route[] = [
	{path: '/', element: <Intro />},
	{path: '/events', element: <Events />},
	{path: '/event-detail', element: <EventDetail />},
	{path: '/setlist', element: <Setlist />},
	{path: '/register', element: <Register />},
	{path: '/verification', element: <Verification />},
	{path: '/verify', element: <Verify />},
	{path: '/wallet', element: <Wallet />},
	{path: '/transaction-detail', element: <TransactionDetail />},
	{path: '/nft-detail', element: <NftDetail />},
];
